import React from 'react'
import { connect } from 'react-redux'
import { addPromo, changePromosFilter, deletePromosSelection } from '../actions/promos'

function mapStateToProps(state, props) {
    const { filters, isFetching, counts, entities } = state.promos
    const filter = filters[props.filterId]
    const count = filter && counts[filter.searchKey]

    return {
        filter,
        count,
        isFetching,
    }
}

function mapDispatchToProps(dispatch, props) {
    return {
        changeFilter: (id, options) => dispatch(changePromosFilter(id, options)),
        add: (options, filterId) => dispatch(addPromo(options, filterId)),
        deleteSelection: (filterId) => dispatch(deletePromosSelection(filterId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
